import React, { useState, useEffect, memo } from 'react';
import { Modal, Timeline, Spin, Icon } from 'antd';
import { ReactComponent as HistoryIcon } from '../../../resource/forms/History.svg';
import moment from 'moment';

const ReqDocHistory = memo(({ visible, hide, getHistory, request, doc }) => {
  const [nodes, setNodes] = useState([]);
  const [nodesLoading, setNodesLoading] = useState();

  useEffect(() => {
    if (visible) {
      (async () => {
        setNodesLoading(true);
        setNodes(await getHistory(request || doc.id));
        setNodesLoading(false);
      })();
    } else {
      setNodes([]);
      setNodesLoading();
    }
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <Modal
      title={
        <span style={{ color: '#0995ed' }}>
          <HistoryIcon
            style={{ height: 40, verticalAlign: 'middle', marginRight: 10 }}
          />
          История изменений {request ? 'заявки ' : 'документа '}
          {request || doc.docNumber}
        </span>
      }
      visible={visible}
      onOk={hide}
      onCancel={hide}
      footer={null}
    >
      <Spin
        size="default"
        spinning={nodesLoading}
        tip="..."
      >
        {nodes && nodes.length > 0 && (
          <Timeline>
            {nodes.map((el, index) => {
              return (
                <Timeline.Item
                  color="#005ebe"
                  key={index}
                >
                  <div>
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#666',
                      }}
                    >
                      {moment(el.date).format('DD-MM-YYYY HH:mm')}
                    </span>
                    <span style={{ marginLeft: 10, marginRight: 10 }}>
                      {el.operation}
                    </span>
                    <span>
                      <Icon
                        style={{ color: '#0066e4' }}
                        type="user"
                      />
                    </span>
                    <span style={{ marginLeft: 5, color: '#0066e4' }}>
                      {el.name}
                    </span>
                  </div>
                  <div>
                    <span>
                      <Icon
                        style={{ color: '#00877e' }}
                        type="caret-right"
                      />
                    </span>
                    <span style={{ marginLeft: 5 }}>{el.newValue}</span>
                  </div>
                </Timeline.Item>
              );
            })}
          </Timeline>
        )}
        {!nodes || (nodes.length === 0 && <div>без изменений</div>)}
      </Spin>
    </Modal>
  );
});

export default ReqDocHistory;
